import script from "./Parceiros.vue?vue&type=script&setup=true&lang=js"
export * from "./Parceiros.vue?vue&type=script&setup=true&lang=js"

import "./Parceiros.vue?vue&type=style&index=0&id=345cb3f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345cb3f8"]])

export default __exports__